import { Module } from 'vuex'
import { RootState } from '@/store'
import { Order } from '@/api/model/order'
import { actions } from '@/store/orders/actions'
import { mutations } from '@/store/orders/mutations'
import { getters } from '@/store/orders/getters'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'
import { OrderStatus, ReferralAge, ReferralFilterDirection, ReferralView } from '@/api/types'
import { OrderCount } from '@/api/model/order-count'

export interface OrdersStateFilters {
    view: ReferralView,
    direction: ReferralFilterDirection
    search: string,
    typeFilter: string[],
    statusFilter: string,
    referredByFilter: User[],
    referredByBranchFilter: Branch[],
    assignedToFilter: User[],
    assignedToBranchFilter: Branch[],
    dateSpecificFilter: Date,
    dateRangeFilter: string,
    ageFilter: ReferralAge,
}

export interface OrdersState extends OrdersStateFilters {
    loading: boolean,
    error: string|null,
    orders: Order[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    orderCounts: OrderCount,
    snapshot: {
        typeFilter: string[],
        referredByFilter: User[],
        referredByBranchFilter: Branch[],
        assignedToFilter: User[],
        assignedToBranchFilter: Branch[],
        dateSpecificFilter: Date,
        dateRangeFilter: string,
        ageFilter: ReferralAge,
    },
}

const state: OrdersState = {
    loading: false,
    error: null,
    orders: [],
    totalItems: null,
    totalPages: 0,
    page: 1,
    itemsPerPage: 10,
    orderField: 'updatedAt',
    orderDirection: 'desc',
    typeFilter: [],
    statusFilter: OrderStatus.PENDING,
    referredByFilter: [],
    referredByBranchFilter: [],
    assignedToFilter: [],
    assignedToBranchFilter: [],
    search: null,
    view: null,
    direction: null,
    dateSpecificFilter: null,
    dateRangeFilter: null,
    ageFilter: null,
    orderCounts: {
        pendingOrders: 0,
        successfulOrders: 0,
        unsuccessfulOrders: 0,
    } as OrderCount,
    snapshot: {
        typeFilter: [],
        referredByFilter: [],
        referredByBranchFilter: [],
        assignedToFilter: [],
        assignedToBranchFilter: [],
        dateSpecificFilter: null,
        dateRangeFilter: null,
        ageFilter: null,
    },
}

export const OrdersModule: Module<OrdersState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
